import React, { Component } from "react";
import { connect } from "react-redux";
import { SelectLoan, IncreaseRefinanceLoan } from "./subcomponents";
import { ConfirmationSummary } from "./subcomponents/ConfirmationSummary";
import {
  LoanInfoApi,
  LeadService,
  newLoanService,
  newLoanStepperService,
  workflowService,
  metadataService,
  ProfileApi,
  SessionService
} from "../_services";
import {
  SlPageTitle,
  SlBusyIndicator,
  SlSectionTitle,
  SlButton,
  SlSectionLabel,
  SlFormEntryRow,
} from "./editors";
import { Col, Row, Card, CardText, CardBody } from "reactstrap";
import { history } from "../_helpers";
import Stepper from "./subcomponents/Stepper";
import { FundingSelection } from "./FundingSelection";
import qs from "query-string";
import validator from 'validator';
import { refinanceIncreaseLoanConstants, workflowConstants } from "../_constants";
import { refinanceIncreaseLoanActions, userActions } from "../_actions";


class IncreaseRefinance extends Component {
  static displayName = IncreaseRefinance.name;
  constructor(props) {
    super(props);
    this.STEP_SELECT_LOAN = 1;
    this.STEP_SELECT_TYPE = 2;
    this.FUNDING_OPTIONS = 3;
    this.COMPLETE = 4;

    //window.alert(props.params.id);
    this.state = {
      currentStep: "",
      canMoveBack: false,
      canMoveForward: true,
      userLoans: [],
      selectedLoan: {},
      canMoveNext: false,
      isWorking: true,
      errorMessage: "",
      requestType: 0,
      requestedAmount: null,
      minLoanAmount: null,
      maxLoanAmount: null,
      changeLoanRequest: {},
      steps: [],
      isEdit: false,
      isRefinance: false,
      fieldErrors: []
    };
    this.handleLoanSelected = this.handleLoanSelected.bind(this);
    this.handleOnNext = this.handleOnNext.bind(this);
    this.handleOnBack = this.handleOnBack.bind(this);
    this.setMoveNext = this.setMoveNext.bind(this);
    this.handleDone = this.handleDone.bind(this);
    this.handleOptionsChanged = this.handleOptionsChanged.bind(this);
    this.handleLoanRequested = this.handleLoanRequested.bind(this);
    this.onDone = this.onDone.bind(this);
    this.navigateToFundsSelection = this.navigateToFundsSelection.bind(this);
    this.navigateToPersonalInfo = this.navigateToPersonalInfo.bind(this);
    this.navigateToNextWorkflowStep = this.navigateToNextWorkflowStep.bind(this);
  }

  componentDidMount() {
    let newState = {
      ...this.state,
    };
    let isEdit = false;
    let isRefinance = false;
    let requestType = 0;
    let requestedAmount = null;
    if(!this.props.loggedIn){     
      this.props.redirectToRefinance() ;
      return history.push("/LogInMain");
    }
    // check for query param indicating user navigated here by edit pencil
    if (this.props.location.search) {
      let query = qs.parse(this.props.location.search);
      if (query.edit) {
        const changeLoan = JSON.parse(sessionStorage.getItem("changeLoanRequest")) || {};
        requestType = changeLoan.requestType || 0;
        requestedAmount = changeLoan.requestedAmount;
        isEdit = true;
      }
      if (query.refi) {
        isRefinance = query.refi;
      }
    }

    let workflowData = workflowService.getCurrentWorkflowStepData();
    if (!workflowData) {
      this.props.handleRefinanceMenuClick();
      workflowData = workflowService.getCurrentWorkflowStepData();
    }
    if (workflowData) {
      newState.steps = newLoanStepperService(workflowData.workflowId);
      newState.currentStep = workflowData.currentStepperStep;
      newState.canMoveBack = workflowData.canMoveBack;
      newState.canMoveForward = workflowData.canMoveForward;
      newState.isEdit = isEdit;
      newState.isRefinance = isRefinance;
    }

    this.handleChangeState(newState);

   

    LoanInfoApi.getUserLoanViews().then(async (response) => {
      let changeLoanRequest = {};
      let currentStep;
      let selectedLoan;
      if (response.data) {
        // if the user has only one loan, skip the first step, else ask user which loan to action on
        // if step jumps to 2, go ahead and set the selected loan to the one loan available
        currentStep = response.data.length > 1 ? 1 : 2
        selectedLoan = currentStep === 2 ? response.data[0] : {}
          Object.assign(changeLoanRequest, selectedLoan)

          let personalInfo = SessionService.getPersonalInfo();
          if (!personalInfo) {
            await ProfileApi.getExtendedProfileInfo().then(result => {
                  personalInfo = {
                      userHash: result.data.userHash,
                      dateOfBirth: result.data.dateOfBirth,
                      firstName: result.data.firstName,
                      lastName: result.data.lastName,
                      socialSecurityNumber: result.data.socialSecurityNumber,
                      individualTaxIdentificationNumber: result.data.individualTaxIdentificationNumber
                  }
              });
          }           
          let fundingInformation = SessionService.getFundingInformation();
          if(fundingInformation){
             metadataService.getBranch(fundingInformation.BranchId).then(response => {
              if (response.status < 1) {
                  let sunLoanOffice = response.data;
                  SessionService.setFundingInformation({
                    ...fundingInformation,
                    sunLoanOffice : sunLoanOffice
                  })
              }
            });

          }

          Object.assign(changeLoanRequest, {
              userHash: personalInfo.userHash,
              dateOfBirth: personalInfo.dateOfBirth,
              firstName: personalInfo.firstName,
              lastName: personalInfo.lastName,
              socialSecurityNumber: personalInfo.socialSecurityNumber,
              individualTaxIdentificationNumber: personalInfo.individualTaxIdentificationNumber,               
          });
          if(isEdit){
            changeLoanRequest = {
              ...changeLoanRequest,
              requestType,
              requestedAmount,
            }
          }
        if (selectedLoan !== {}) sessionStorage.setItem("changeLoanRequest", JSON.stringify(changeLoanRequest));
      }

      this.setState({
        userLoans: response.data,
        currentStep,
        selectedLoan,
        isWorking: false, 
        requestType,
        requestedAmount,
      });
    });
  }

    updateLoanAmounts = async (state) => {
       return newLoanService.validateState(state).then(stateValidation => {
            let { doesBusinessInState, minLoanAmount, maxLoanAmount } = stateValidation.data;

            if (!doesBusinessInState) {
                minLoanAmount = null;
                maxLoanAmount = null;
            }

            this.handleChangeState({
                ...this.state,
                minLoanAmount,
                maxLoanAmount
            });
        });
    }

  handleChangeState(newState) {
      newState.formError = this.formHasError(newState);
      if (newState.formError) {
          newState.canMoveNext = false;
      }
        this.setState(newState);
    }
    
    formHasError(stateData) {
        let hasError = false; 
        if (stateData.requestType === 2) {
          if(metadataService.isNullOrEmpty(stateData.requestedAmount)){
            hasError = true;
          }else if(parseFloat(stateData.requestedAmount) <= 0){
            hasError = true;
          }
        } 
        return hasError;
    }

  handleOnNext() {
    //TODO: Handle on next needs to account for refinance edit process (navigate to summary page on save click)
    let nextStep = 0;
    switch (this.state.currentStep) {
      case this.STEP_SELECT_LOAN:
        nextStep = this.STEP_SELECT_TYPE;
        break;
      default:
        nextStep = this.state.currentStep + 1;
        break;
    }
    this.setState({ currentStep: nextStep });
  }

  navigateToFundsSelection() {
    this.handleOnNext();
    let workflowData = workflowService.getCurrentWorkflowStepData();
    Object.assign(workflowData, {
      currentStepperStep: this.state.currentStep,
      canMoveBack: this.state.canMoveBack,
      canMoveForward: this.state.canMoveForward,
    });

    sessionStorage.setItem("workflowData", JSON.stringify(workflowData));

    history.push("/Refinance/FundingSelection");
  }
  navigateToPersonalInfo() {
    this.handleOnNext();
    let workflowData = workflowService.getCurrentWorkflowStepData();
    Object.assign(workflowData, {
      currentStepperStep: this.state.currentStep,
      canMoveBack: true,
      canMoveForward: this.state.canMoveForward,
    });
    sessionStorage.setItem("workflowData", JSON.stringify(workflowData));
    history.push("/Refinance/PersonalInfo");
  }

  navigateToNextWorkflowStep = () => this.props.handleIncreaseRefinanceNextRequest();
  handleDone() {
    history.push("/account-history");
  }

  handleOnBack() {
    let nextStep = 0;
    switch (this.state.currentStep) {
      case this.STEP_SELECT_LOAN:
        //not valid;
        break;
      default:
        nextStep = this.state.currentStep - 1;
        break;
    }
    if (nextStep > 0) {
      this.setState(this.setMoveNext({ currentStep: nextStep }));
    }
  }
    handleLoanSelected(currentLoanId) {
    const selectedLoan = this.state.userLoans.find(function (e) {
        return e.currentLoanId === currentLoanId;
    });

    this.setState(
      this.setMoveNext({
        selectedLoan: selectedLoan,
        paymentAmount: selectedLoan.minimumPaymentDue,
      })
    );
  }

  handleOptionsChanged(refinanceOption) {
      let { changeLoanRequest } = this.state;
      let newChangeLoan = JSON.parse(sessionStorage.getItem("changeLoanRequest"));
      Object.assign(refinanceOption, changeLoanRequest);
      Object.assign(newChangeLoan, refinanceOption);
      sessionStorage.setItem("changeLoanRequest", JSON.stringify(newChangeLoan));
      this.handleChangeState(this.setMoveNext(refinanceOption));
  }

  handleLoanRequested() {
    const changeLoanRequest = {
        currentLoanId: this.state.selectedLoan.currentLoanId,
      requestType: this.state.requestType,
      LeadType: LeadService.LEADTYPE_REFINANCE_LOAN_REQUEST,
      requestedAmount:  this.state.requestedAmount ,
    };
    this.setState({
      currentStep: this.FUNDING_OPTIONS,
      changeLoanRequest,
    });
  }

  setMoveNext(stateChanges) {
    const newState = { ...this.state, ...stateChanges };
    let canMoveNext = false;

    if (newState.currentStep === this.STEP_SELECT_LOAN && !stateChanges.formError) {
      //need to have a current loan
      canMoveNext = newState.selectedLoan != null;
    }

    return {
      ...stateChanges,
      ...{ canMoveNext: canMoveNext, errorMessage: null },
    };
  }

  onDone() {
    // submit the refinance / increase
    // LeadService.submitChangeLoanRequest(changeLoanRequest)
    //   .then(result => this.setState({isWorking: false, currentStep : this.STEP_COMPLETE }))
  }

  render() {
    return (
      <div>
        {this.state.currentStep > this.STEP_SELECT_LOAN &&
          this.state.currentStep < this.FUNDING_OPTIONS && (
            <div id="backBtnContainer" hidden>
              <SlButton name="Back" onClick={this.handleOnBack} />
            </div>
          )}
        <div className="text-center">
          <Stepper stepData={this.state.steps} currentStep={0} />
          <Row className="justify-content-center">
            <Col xs={12} sm={12} md={8} lg={8}>
              <SlPageTitle pageName="IncreaseRefinance" />
            </Col>
          </Row>
          {(this.state.isWorking && <SlBusyIndicator visible="true" />) ||
            (this.state.currentStep === this.STEP_SELECT_LOAN && (
              <React.Fragment>
                <Card>
                  <CardBody className="pb-0">
                    <Row className="justify-content-center">
                      <Col xs={12} sm={12} md={8} lg={8} className="text-left">
                        <h6 className={"h6-title"}>
                          {metadataService.getTitle("SelectLoan")}
                        </h6>
                      </Col>
                    </Row>
                    {this.state.userLoans.map((e) => {
                      return (
                        <SelectLoan
                              key={e.currentLoanId}
                          loan={e}
                          onLoanSelected={this.handleLoanSelected}
                          isSelected={
                              e.currentLoanId ===
                              this.state.selectedLoan.currentLoanId
                          }
                        />
                      );
                    })}
                  </CardBody>
                </Card>
              </React.Fragment>
            )) ||
            (this.state.currentStep === this.STEP_SELECT_TYPE && (
              <React.Fragment>
                <Card>
                  <CardBody className="pb-0">
                    <Row className="justify-content-center">
                      <Col xs={12} sm={12} md={8} lg={8} className="text-left">
                        <h6 className={"h6-title"}>
                          {metadataService.getTitle("SelectLoan")}
                        </h6>
                      </Col>
                    </Row>
                    <IncreaseRefinanceLoan
                                    loan={this.state.selectedLoan}
                                    requestType={this.state.requestType}
                                    requestedAmount={this.state.requestedAmount}
                                    requestLoan={
                                        this.state.currentStep === 2
                                            ? this.navigateToNextWorkflowStep
                                            : this.handleLoanRequested
                                    }
                                    optionsChanged={this.handleOptionsChanged}
                                    fieldErrors={this.state.fieldErrors}
                                    formError={this.state.formError}
                                    minLoanAmount={this.state.minLoanAmount}
                                    maxLoanAmount={this.state.maxLoanAmount}
                                    isEdit={this.state.isEdit}
                    />
                  </CardBody>
                </Card>
              </React.Fragment>
            ))}
        </div>
        <div>
          <div className="text-center">
            {this.state.isEdit ? (
              <SlButton size="lg" disabled={this.state.isWorking} name={"Save"} onClick={this.navigateToNextWorkflowStep} /> // update to handle refinance edit process, see handle next function
            ) : (
              <div>
                {this.state.currentStep === 1 && (
                  <SlButton
                    name="Next"
                    size="lg"
                    onClick={
                      this.state.currentStep === 2
                        ? this.navigateToNextWorkflowStep
                        : this.handleOnNext
                    }
                    disabled={!this.state.canMoveNext || this.state.isWorking}
                  />
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
    const { loggedIn } = state.authentication;
    const { userState } = state.registration;
    return {
        loggedIn, userState
    };
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    handleRefinanceMenuClick: () => {
      dispatch(refinanceIncreaseLoanActions.handleRefinanceMenuClick());
    },
    redirectToRefinance :  () => dispatch(userActions.handleRedirectFromLogin()),
    handleIncreaseRefinanceNextRequest : () => dispatch(refinanceIncreaseLoanActions.handleIncreaseRefinanceNextRequest()),
  };
};

const connectedIncreaseRefinance = connect(
  mapStateToProps,
  mapDispatchToProps
)(IncreaseRefinance);
export { connectedIncreaseRefinance as IncreaseRefinance };
